import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=33a9668f"
import script from "./PromotionsList.vue?vue&type=script&lang=js"
export * from "./PromotionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports